import './medals.css';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faMedal, faFire, faPencil, faBook, faStar, faLock } from '@fortawesome/free-solid-svg-icons';

const apiUrl = process.env.REACT_APP_API_URL;

const Medals = () => {
  const [medals, setMedals] = useState([]);
  const [loading, setLoading] = useState(true);

  // Mock data pentru medalii - vei înlocui cu date reale din API
  const allMedals = [
    {
      id: 1,
      name: 'Streak Master',
      description: 'Completează 7 zile consecutive de învățare',
      icon: faFire,
      type: 'streak',
      requirement: 7,
      color: '#ff6b35',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    },
    {
      id: 2,
      name: 'Streak Legend',
      description: 'Completează 30 zile consecutive de învățare',
      icon: faFire,
      type: 'streak',
      requirement: 30,
      color: '#ff4500',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    },
    {
      id: 3,
      name: 'Exerciții Pro',
      description: 'Rezolvă 50 de exerciții',
      icon: faPencil,
      type: 'exercises',
      requirement: 50,
      color: '#4f8cff',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    },
    {
      id: 4,
      name: 'Master Exerciții',
      description: 'Rezolvă 200 de exerciții',
      icon: faPencil,
      type: 'exercises',
      requirement: 200,
      color: '#2563eb',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    },
    {
      id: 5,
      name: 'Primul Curs',
      description: 'Finalizează primul curs',
      icon: faBook,
      type: 'courses',
      requirement: 1,
      color: '#13b8ab',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    },
    {
      id: 6,
      name: 'Expert Contabil',
      description: 'Finalizează toate cursurile',
      icon: faTrophy,
      type: 'courses',
      requirement: 2,
      color: '#ffd700',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    },
    {
      id: 7,
      name: 'Începător Dedicat',
      description: 'Obține 100 XP',
      icon: faStar,
      type: 'xp',
      requirement: 100,
      color: '#ffb300',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    },
    {
      id: 8,
      name: 'XP Champion',
      description: 'Obține 1000 XP',
      icon: faStar,
      type: 'xp',
      requirement: 1000,
      color: '#ff8c00',
      unlocked: false,
      progress: 0,
      unlockedAt: null
    }
  ];

  useEffect(() => {
    const fetchMedals = async () => {
      try {
        // Aici vei face request la API pentru medaliile utilizatorului
        // const response = await fetch(`${apiUrl}/user/medals`, {
        //   credentials: 'include',
        // });
        // const data = await response.json();
        // setMedals(data);
        
        // Deocamdată folosim mock data
        setMedals(allMedals);
      } catch (error) {
        console.error('Error fetching medals:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMedals();
  }, []);

  const unlockedMedals = medals.filter(m => m.unlocked);
  const lockedMedals = medals.filter(m => !m.unlocked);

  if (loading) {
    return (
      <div className="medals-page">
        <div className="medals-header">
          <h1>🏅 Medaliile Tale</h1>
        </div>
        <div className="medals-content">
          <p className="loading-message">Se încarcă...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="medals-page">
      <div className="medals-header">
        <h1>🏅 Medaliile Tale</h1>
        <p className="medals-subtitle">
          Colecționează medalii completând provocări și atingând obiective
        </p>
       
      </div>

      <div className="medals-stats">
        <div className="medals-stat-item">
          <span className="stat-number">{unlockedMedals.length}</span>
          <span className="stat-label">Deblocate</span>
        </div>
        <div className="medals-stat-divider"></div>
        <div className="medals-stat-item">
          <span className="stat-number">{medals.length}</span>
          <span className="stat-label">Total</span>
        </div>
        <div className="medals-stat-divider"></div>
        <div className="medals-stat-item">
          <span className="stat-number">{Math.round((unlockedMedals.length / medals.length) * 100)}%</span>
          <span className="stat-label">Progres</span>
        </div>
      </div>

      <div className="medals-content">
        {unlockedMedals.length > 0 && (
          <div className="medals-section">
            <h2 className="section-title">✨ Medalii Deblocate</h2>
            <div className="medals-grid">
              {unlockedMedals.map((medal) => (
                <div key={medal.id} className="medal-card unlocked">
                  <div className="medal-icon-container" style={{ backgroundColor: medal.color }}>
                    <FontAwesomeIcon icon={medal.icon} className="medal-icon" />
                  </div>
                  <h3 className="medal-name">{medal.name}</h3>
                  <p className="medal-description">{medal.description}</p>
                  {medal.unlockedAt && (
                    <p className="medal-unlocked-date">
                      Deblocat pe {new Date(medal.unlockedAt).toLocaleDateString('ro-RO')}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {lockedMedals.length > 0 && (
          <div className="medals-section">
            <h2 className="section-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <FontAwesomeIcon icon={faLock} style={{ fontSize: 28, color: '#ffb300', marginBottom: 2 }} />
              Medalii Blocate
            </h2>
            <div className="medals-grid">
              {lockedMedals.map((medal) => (
                <div key={medal.id} className="medal-card locked">
                  <div className="medal-icon-container locked-icon">
                    <FontAwesomeIcon icon={faLock} className="medal-icon lock-icon" />
                  </div>
                  <h3 className="medal-name">{medal.name}</h3>
                  <p className="medal-description">{medal.description}</p>
                  <div className="medal-progress">
                    <div className="progress-bar-container-medal">
                      <div 
                        className="progress-bar-fill" 
                        style={{ 
                          width: `${(medal.progress / medal.requirement) * 100}%`,
                          backgroundColor: medal.color
                        }}
                      ></div>
                    </div>
                    <p className="progress-text">
                      {medal.progress} / {medal.requirement}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {medals.length === 0 && (
          <div className="medals-empty-state">
            <div className="empty-icon">
              <FontAwesomeIcon icon={faMedal} />
            </div>
            <h2>Încă nu ai medalii</h2>
            <p>Începe să înveți pentru a debloca prima ta medalie!</p>
            <Link to="/cursuri" className="btn-start-learning">
              Începe să înveți
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Medals;
